import { API_URL } from '../../../configs/services/services.config';

export const URL = {
  postLogIn: `${API_URL}/auth/token/signaller`,
  deleteToken: `${API_URL}auth/token/{token}`,
} as const;
